import React from 'react';
import { Box, Typography } from '@material-ui/core';
import 'swiper/css/swiper.css';

import ScheduleFilters from './ScheduleFilters';
import RowHeaders from './RowHeaders';
import ColumnTimeTable from './ColumnTimeTable';
import ColumnsAppointments from './ColumnsAppointments';
import useStyles from './styles';
import { ScheduleProvider } from './context';

const Schedule = () => {
  const classes = useStyles();

  return (
    <ScheduleProvider>
      <Box className={classes.container}>
        <Box className="schedule-header">
          <Typography className="schedule-header-title">
            Selecione um horário para o agendamento:
          </Typography>
          <ScheduleFilters />
        </Box>
        <Box className="schedule-body">
          <Box className="schedule-body-fixed">
            <RowHeaders />
          </Box>
          <Box className="schedule-body-scrollable">
            <ColumnTimeTable />
            <ColumnsAppointments />
          </Box>
        </Box>
      </Box>
    </ScheduleProvider>
  );
};

export default Schedule;
